// extracted by mini-css-extract-plugin
export default {"mediaSlotInOverlay":"b5mTr7","mediaSlotInOverlayStunning":"pyTX8s"};